import { useOutletContext } from "react-router";
import type { Database } from "../../lib/types";

export interface DatabaseTabContext {
  orgId: string | undefined;
  /*
   * The database itself, not just its id — the shell has already fetched and
   * error-handled it, and a tab refetching by id would put a second loading
   * state inside a page that has finished loading.
   */
  database: Database;
}

export function useDatabaseTabContext(): DatabaseTabContext {
  return useOutletContext<DatabaseTabContext>();
}
